// Module
var code = `<div class="alert">
  <span><strong>Hint:</strong> To change approval hierarchy you can drag and drop the level using "Move" button.</span>
</div>

<approval-hierarchy
    approval-hierarchy="\$ctrl.approvalHierarchy"
    save="\$ctrl.save"
    use-external-save-action="true"
    min-levels="1"
>
</approval-hierarchy>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/access-rule-approval-hierarchy/access-rule-approval-hierarchy.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;